import type { CopyShape } from "@tami/core/intl";

import type { DASHBOARD_COLLAB_SCRIPT_COPY_PT_BR } from "../dashboard-collab-script.copy";

export const DASHBOARD_COLLAB_SCRIPT_COPY_ES_ES: CopyShape<typeof DASHBOARD_COLLAB_SCRIPT_COPY_PT_BR> = {
  dashCollabIntro: {
    narrative: "El mismo panel, desde el lado de quien gestiona: toda la cartera de creators en una sola pantalla.",
  },
  dashCollabScope: {
    narrative: "Elige de quién quieres hablar. Un creator, unos cuantos o la cartera entera — toda la pantalla se adapta.",
    callout: "Filtra por creator en un clic — incluida tu propia Collab.",
  },
  dashCollabGreeting: {
    narrative: "Empieza el día sabiendo qué tiene que publicar, entregar y resolver cada creator.",
    callout: "¡Buenos días, Ana! El resumen de la cartera de un vistazo.",
  },
  dashCollabOverview1: {
    narrative: "Menos hojas de cálculo por creator — un solo sitio para toda la cartera.",
  },
  dashCollabCards: {
    narrative: "Cada creator con seguidores y engagement consolidados. Haz clic en una tarjeta y baja hasta sus redes.",
    callout: "Una tarjeta por creator — y tu Collab también tiene la suya.",
  },
  dashCollabOverview2: {
    narrative: "Comparación lado a lado, sin abrir una pestaña por creator.",
  },
  dashCollabKpis: {
    narrative: "Ingresos, campañas activas, entregas pendientes y engagement — sumados de toda la cartera.",
    callout: "KPIs consolidados: lo que la Collab tiene en marcha ahora mismo.",
  },
  dashCollabOverview3: {
    narrative: "Sin suposiciones sobre quién está entregando y quién está parado.",
  },
  dashCollabPosts: {
    narrative: "La cola del día con el responsable de cada elemento — repasas la columna y sabes qué es de quién.",
    callout: "Cada publicación lleva su creator, incluido el contenido de la Collab.",
  },
  dashCollabAgenda: {
    narrative: "Grabaciones, llamadas y reuniones de la cartera, con el creator de cada cita.",
    callout: "Calendario de la cartera: quién graba, quién se reúne y a qué hora.",
  },
};
